<template>
  <div class="login-container">
    <!-- 背景层 -->
    <div class="background-layer">
      <div class="gradient-bg"></div>
      <div class="hexagon-pattern"></div>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- Logo和品牌区域 -->
      <header class="login-header" :style="{paddingTop: statusBarHeight + 'px'}">
        <div class="login-header-content">
          <div class="logo-wrapper" @click="ecg()">
            <img class="logo-img" src="@/assets/login/Headicon.png" alt="大救星" />
            <div class="logo-badge">
              <!-- <img src="@/assets/login/HeadSubtitleBackground.png" alt="健康版" class="badge-bg" />
              <span class="badge-text">健康版</span> -->
            </div>
          </div>
          <div class="app-name">大救星</div>
          <!-- 特性标签 -->
          <div class="features">
            <div class="feature-item">
              <img src="@/assets/login/Securityicon.png" alt="安全" class="feature-icon" />
              <span class="feature-text">安全</span>
            </div>
            <div class="feature-item">
              <img src="@/assets/login/Accurateicon.png" alt="精准" class="feature-icon" />
              <span class="feature-text">精准</span>
            </div>
            <div class="feature-item">
              <img src="@/assets/login/Healthicon.png" alt="健康" class="feature-icon" />
              <span class="feature-text">健康</span>
            </div>
          </div>
        </div>
      </header>

      <!-- 登录表单卡片 -->
      <div class="login-card">
        <div class="card-title">账号登录</div>
        
        <!-- 账号输入框 -->
        <div class="input-wrapper">
          <img class="input-icon" src="@/assets/login/Accounticon.png" alt="账号" />
          <el-input 
            class="login-input"
            placeholder="请输入账号" 
            v-model="phone" 
            clearable>
          </el-input>
        </div>

        <!-- 验证码输入框 -->
        <div class="input-wrapper password-wrapper">
          <img class="input-icon" src="@/assets/login/Verificationcodeicon.png" alt="验证码" />
          <el-input 
            class="login-input"
            placeholder="请输入验证码" 
            v-model="password" 
            clearable>
          </el-input>
          <div 
            class="verify-code-btn" 
            :class="{ 'disabled': disabled }"
            v-if="title=='获取验证码'" 
            @click.stop="getCode()">
            {{title}}
          </div>
          <div class="verify-code-btn disabled" v-else @click.stop>{{title}}</div>
        </div>

        <!-- 登录按钮 -->
        <button class="login-btn" @click="login()">账号登录</button>

        <!-- 注册链接 -->
        <div class="register-link">
          <span class="register-text">没有账号?</span>
          <span class="register-link-text" @click="handleRegister">去注册</span>
        </div>
         <!-- 用户协议 -->
      <div class="agreement-section">
        <div class="agreement-checkbox" @click="act = !act">
          <div class="checkbox-icon" :class="{ 'checked': act }">
            <img v-if="act" src="./img/Selected.png" alt="已选" />
            <img v-else src="./img/notselected.png" alt="未选" />
          </div>
          <span class="agreement-text">
            我已阅读并同意<span class="link-text" @click.stop="agreement()">《用户协议》</span>和<span class="link-text" @click.stop="agreement()">《隐私政策》</span>
          </span>
        </div>
      </div>
      </div>

     
    </div>
  </div>
</template>

<script>
// stores
import { mapActions, mapState } from 'pinia';
import { useUserStore } from '@/stores/user';
import { useGlobalStore } from '@/stores/global';
// service
import { pin,login } from '@/api/activity'

export default {
  data() {
    return {
      type:'1',
      act:false,
      password: "",
      phone: "",
      second: "", //倒计时
      disabled: false, //是否禁用按钮
      timer: null, //计时器
      user: {
        oldPassword: "", //旧密码
        password: "", //密码
        password2: "", //密码
        userName: "", //个人姓名
        phone: "", //手机号码
        certificationId: "", //身份证号
        code: "", //验证码
      },
    };
  },
  mounted() {
    document.title = '登录'
    console.log(localStorage.getItem('token'),61)
    localStorage.clear();
    console.log(localStorage.getItem('token'),63)
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
    title() {
      return this.disabled ? `${this.second}s` : "获取验证码";
    },
  },
  methods: {
    ecg() {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfcd095e9dac59f04c3'
    },
    login() {
      if(!this.act) {
        this.$message.error('请阅读用户隐私协议');
        return
      }
      login({phone:this.phone,authCode:this.password}).then((res)=>{
        if(res.code == 1000) {
          console.log(res)
          // 保存用户信息
          this.setUserInfo(res.data || {});
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('userCode', res.data.userCode)
          console.log(localStorage.getItem('token'),86)
          // 将用户信息传递给原生app
          if (this.$env.inDjxApp){
            if (this.$env.inAndroid){
               try {
                JSInterface.saveUserInfo(JSON.stringify(res.data))
              } catch (error) {
                console.log(error)
              }
            }else if (this.$env.inIos) {
              try {
                window.webkit.messageHandlers.saveUserInfo.postMessage(JSON.stringify(res.data));
              } catch (error) {
                console.log(error)
              }
            }
          }
         
          if(this.type == 1) {
            // 老年版需要
            if(res.data.isNewUser) {
              this.$router.push({
              path: "/informationGathering",
              query:{
              }
            });
            }else {
              this.$router.push({
                  path: "/healthHomePage",
                  query:{
                  }
                });
             
            }
           
            // this.$router.push({
            //       path: "/healthHomePage",
            //       query:{
            //       }
            //     });
          
          }
        }
      })
    },
    /**
     * 处理注册链接点击
     */
    handleRegister() {
      this.$router.push({
        path: "/register",
        query: {}
      });
    },
    agreement() {
      this.$router.push({
              path: "/agreement",
              query:{
              }
            });
    },
    //获取短信验证码
    getCode() {
      pin(this.phone).then((res)=>{
        console.log(res)
      })
      console.log("点击");
      let that = this;
      let s = 60; //倒计时间
      if (!that.timer) {
        that.second = s;
        that.disabled = true;
        that.timer = setInterval(() => {
          if (that.second > 0 && this.second <= s) {
            that.second--;
          } else {
            that.disabled = false;
            clearInterval(that.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    ...mapActions(useUserStore, ['setUserInfo'])
  }
};
</script>
<style scoped>
/* 主容器 */
.login-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 背景层 */
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.gradient-bg {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #A0EDD2 0%, rgba(255, 255, 255, 0.9) 50%, #FFFFFF 100%);
}

.hexagon-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background-image: 
    repeating-linear-gradient(60deg, transparent, transparent 40px, rgba(255,255,255,0.15) 40px, rgba(255,255,255,0.15) 80px),
    repeating-linear-gradient(120deg, transparent, transparent 40px, rgba(255,255,255,0.15) 40px, rgba(255,255,255,0.15) 80px);
  opacity: 0.4;
  background-size: 80px 80px;
}

/* 内容包装器 */
.content-wrapper {
  position: relative;
  z-index: 1;
  /* padding: 80px 20px 40px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}

/* 登录头部区域 */
.login-header {
  /* margin-bottom: 50px; */
  width: 100%;
  background: url('~@/assets/login/headbackground.png') no-repeat center top;
  background-size: 100% auto;
  background-color: #E5F6F1;
  padding-top: 24px;
  padding-bottom: 20px;
  /* border-radius: 0 0 20px 20px; */
}

.login-header-content {
  text-align: center;
  padding: 0 20px;
  margin-top: 50px;
}

.logo-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 18px;
  cursor: pointer;
}

.logo-img {
  width: 58px;
  height: 58px;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
}

.logo-badge {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
}

.badge-bg {
  width: 50px;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.badge-text {
  position: relative;
  font-size: 9px;
  color: #333;
  font-weight: 500;
  z-index: 1;
  white-space: nowrap;
}

.app-name {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
  /* margin-top: 8px; */
}

/* 特性标签 */
.features {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 16px;
}

.feature-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  background-image: url('~@/assets/login/HeadSubtitleBackground.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding: 4px 12px;
  min-width: 60px;
}

.feature-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}

.feature-text {
  font-size: 12px;
  color: #333;
  font-weight: 400;
  white-space: nowrap;
}

/* 登录表单卡片 */
.login-card {
  width: 100%;
  max-width: 340px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 14px 24px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: left;
  margin-bottom: 24px;
}

/* 输入框包装器 */
.input-wrapper {
  position: relative;
  margin-bottom: 26px;
  display: flex;
  align-items: center;
  background: #F5F5F5;
  border-radius: 22px;
  padding: 0 16px;
  height: 48px;
}

.password-wrapper {
  padding-right: 8px;
}

.input-icon {
  width: 16px;
  height: 16px;
  margin-right: 12px;
  flex-shrink: 0;
}

.login-input {
  flex: 1;
}

::v-deep .login-input .el-input__inner {
  border: none !important;
  border-width: 0 !important;
  outline: none !important;
  background: transparent !important;
  padding: 0 !important;
  font-size: 15px;
  color: #333;
  height: 48px;
  line-height: 48px;
  box-shadow: none !important;
}

::v-deep .login-input .el-input__inner:hover {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .login-input .el-input__inner:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

::v-deep .login-input.is-focus .el-input__inner {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .login-input .el-input__wrapper {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .login-input .el-input__inner::placeholder {
  color: #999;
}

/deep/ .login-input.el-input--suffix .el-input__inner {
  background-color: #F5F5F5 !important;
  border: none !important;
}

.verify-code-btn {
  margin-left: auto;
  padding-left: 8px;
  border-left: 1px solid #E0E0E0;
  font-size: 14px;
  color: #00BB82;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  height: 24px;
  line-height: 24px;
  user-select: none;
}

.verify-code-btn.disabled {
  color: #999;
  cursor: not-allowed;
  border-left-color: #E0E0E0;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 48px;
  background: url('~@/assets/login/Loginbuttonbackground.png') no-repeat center center;
  background-size: 100% 100%;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  margin-top: 13px;
  margin-bottom: 16px;
  transition: all 0.3s;
}

.login-btn:active {
  opacity: 0.8;
  transform: scale(0.98);
}

/* 注册链接 */
.register-link {
  text-align: center;
  /* margin-top: 16px; */
}

.register-text {
  font-size: 14px;
  color: #999;
}

.register-link-text {
  font-size: 14px;
  color: #00BB82;
  font-weight: 500;
  margin-left: 4px;
  cursor: pointer;
}

/* 用户协议区域 */
.agreement-section {
  width: 100%;
  max-width: 340px;
  margin-top: 20px;
}

.agreement-checkbox {
  text-align: center;
  display: flex;
  align-items: center;
  /* gap: 8px; */
}

.checkbox-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.checkbox-icon img {
  width: 100%;
  height: 100%;
}

.agreement-text {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  flex: 1;
}

.link-text {
  color: #00BB82;
  cursor: pointer;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .login-card {
    padding: 14px 20px;
  }
  
  .app-name {
    font-size: 18px;
  }
  
  .features {
    gap: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue